import { App, Result, Spin } from "antd";
import { observer } from "mobx-react";
import { useMemo } from "react";
import { createHashRouter, createRoutesFromElements, Outlet, Route, RouterProvider } from "react-router-dom";
import { AccountTabs, AccountHeader, CreateAccountEnvatoForm, AccountExpiredPaymentDetails, AccountAffiliateSignUp, AccountAffiliateTransactionsTable, AccountAffiliateLinksForm, AccountAffiliateCouponsForm, AccountAffiliatePayoutsTable } from ".";
import { RealCommerceError } from "../../exceptions";
import { useAccountEmailConfirmationToken, useAccountRenewedHookPersist } from "../../hooks";
import { providedModal } from "../../others";
import { useStores } from "../../store";
import { __ } from "../../utils";
const AccountRouter = () => {
  const router = useMemo(() => createHashRouter(createRoutesFromElements( /*#__PURE__*/React.createElement(Route, {
    element: /*#__PURE__*/React.createElement(AccountRouterLayout, null)
  }, /*#__PURE__*/React.createElement(Route, {
    path: "/create-account",
    element: /*#__PURE__*/React.createElement(CreateAccountEnvatoForm, null)
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/envato-purchase",
    element: /*#__PURE__*/React.createElement(CreateAccountEnvatoForm, null)
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/create-affiliate",
    element: /*#__PURE__*/React.createElement(AccountAffiliateSignUp, null)
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/expired-payment-details/:uuid",
    element: /*#__PURE__*/React.createElement(AccountExpiredPaymentDetails, null)
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/affiliate",
    element: /*#__PURE__*/React.createElement(AccountTabs, null)
  }, /*#__PURE__*/React.createElement(Route, {
    index: true,
    element: /*#__PURE__*/React.createElement(AccountAffiliateTransactionsTable, null)
  }), /*#__PURE__*/React.createElement(Route, {
    path: "links",
    element: /*#__PURE__*/React.createElement(AccountAffiliateLinksForm, null)
  }), /*#__PURE__*/React.createElement(Route, {
    path: "coupons",
    element: /*#__PURE__*/React.createElement(AccountAffiliateCouponsForm, null)
  }), /*#__PURE__*/React.createElement(Route, {
    path: "payouts",
    element: /*#__PURE__*/React.createElement(AccountAffiliatePayoutsTable, null)
  }), /*#__PURE__*/React.createElement(Route, {
    path: "edit",
    element: /*#__PURE__*/React.createElement(AccountAffiliateSignUp, null)
  })), /*#__PURE__*/React.createElement(Route, {
    path: "/:tab?",
    element: /*#__PURE__*/React.createElement(AccountTabs, null)
  })))), []);
  return /*#__PURE__*/React.createElement(RouterProvider, {
    router: router
  });
};
const AccountRouterLayout = observer(() => {
  const {
    message,
    modal
  } = App.useApp();
  const {
    accountStore
  } = useStores();
  const {
    session
  } = accountStore;
  useAccountEmailConfirmationToken(async emailConfirmationToken => {
    const hide = message.loading(__("Confirming your new email address..."));
    try {
      await accountStore.updateEmailAddress(emailConfirmationToken);
      message.success("Successfully updated your email address!");
    } catch (e) {
      if (e instanceof RealCommerceError) {
        providedModal("error", /*#__PURE__*/React.createElement(Result, {
          title: e.message,
          status: "500",
          style: {
            paddingBottom: 15
          }
        }), modal);
      }
    } finally {
      hide();
    }
  });
  useAccountRenewedHookPersist();
  return /*#__PURE__*/React.createElement(Spin, {
    spinning: !!(session !== null && session !== void 0 && session.busy) || !!(session !== null && session !== void 0 && session.busyAffiliate)
  }, session && /*#__PURE__*/React.createElement(AccountHeader, null), /*#__PURE__*/React.createElement(Outlet, null));
});
export { AccountRouter };